<template>
	<div class="services">
		<div class="site-content">
			<div class="page-header" :style="{backgroundImage:`url(${require('../assets/images/subheader-career.jpg')})`}" style="background:no-repeat center center;">
			    <div class="container">
			        <div class="breadc-box no-line">
			            <div class="row">
			                <div class="col-md-12">
			                    <h2 class="page-title">微信订房点餐系统</h2>
			                    <ul id="breadcrumbs" class="breadcrumbs none-style">
			                        <li><router-link :to="{name: 'home'}" class="active_item" exact>首页</router-link></li>
			                        <li class="active">产品服务</li>
			                    </ul>
			                </div>
			            </div>
			        </div>
			    </div>
			</div>
			<section>
				<div class="container">
					<div class="row flex-row">
						<div class="col-sm-7 col-xs-12">
							<h4 class="text-primary">软件介绍</h4>
							<h2>邦威微信酒店订房点餐系统</h2>
							<p>邦威微信酒店订房点餐系统是邦威软件有限公司与腾讯官方合作，于2015年结合腾讯微信平台开发打造的一款酒店订房点餐应用，成为在微信酒店订房点餐这一领域的先行者</p>

							<p>该产品可以嵌入微信公众账号中，使酒店微信公众号的粉丝，只需使用微信扫描酒店二维码或在微信中搜索微信号或酒店名称，就可以找到并关注，执行公众号中的相应操作，就可以实现通过地理位置、城市、地区来订房了。</p>

							<p>除了订房功能之外，还可以进行九点展示、房型展示，实现CRM客户管理等一系列人性化服务，帮助酒店实现常客计划。</p>

							<p>目前有很多酒店都在使用微信订房，利用微信公众账号与粉丝开展互动活动，增强粉丝粘度，有效发展新会员。充分利用微信公众账号实现客户分组，便于客户管理，节约客户维护成本，实实在在的为酒店直销实现价值</p>
						</div>
						<div class="col-sm-5 col-xs-12 align-self-center text-right text-mb-left">
							<div class="career-download">
								<img src="../assets/images/career-img-weixin.jpg" alt="">
							</div>
							<div class="industris-space-xs"></div>
						</div>			
					</div>

					<div class="industris-space-30 sm-hidden"></div>
					
					<div class="row">
						<div class="col-md-12">
							<div class="industris-space-50"></div>

							<swiper :options="swiperOption" ref="mySwiper" @someSwiperEvent="callback">
									<swiper-slide>
										<img src="../assets/images/wx-img-1.png" alt="">
									</swiper-slide>

									<swiper-slide>
										<img src="../assets/images/wx-img-2.png" alt="">
									</swiper-slide>

									<swiper-slide>
										<img src="../assets/images/wx-img-3.png" alt="">
									</swiper-slide>

									<swiper-slide>
										<img src="../assets/images/wx-img-4.png" alt="">
									</swiper-slide>

									<swiper-slide>
										<img src="../assets/images/wx-img-5.png" alt="">
									</swiper-slide>

									<swiper-slide>
										<img src="../assets/images/wx-img-6.png" alt="">
									</swiper-slide>

									<swiper-slide>
										<img src="../assets/images/wx-img-7.png" alt="">
									</swiper-slide>

									<swiper-slide>
										<img src="../assets/images/wx-img-8.png" alt="">
									</swiper-slide>

									<swiper-slide>
										<img src="../assets/images/wx-img-9.png" alt="">
									</swiper-slide>

									<swiper-slide>
										<img src="../assets/images/wx-img-10.png" alt="">
									</swiper-slide>
							</swiper>
							
							<div class="swiper-button-prev" slot="button-prev"></div>
							<div class="swiper-button-next" slot="button-next"></div>
						</div>		
					</div>
					<div class="industris-space-60"></div>
			    </div>
			</section>
		</div>
			
	</div>
</template>

<script> 
	import 'swiper/dist/css/swiper.css'
	import {swiper,swiperSlide} from "vue-awesome-swiper"

	export default {
        name: 'services_weixin',  
		components: {swiper,swiperSlide},
		data(){
			return{
				swiperOption:{
					speed:2000,
					autoplay:{
						delay:3000,
						disableOnInteraction:false
					},
					slidesPerView : 3,
					slidesPerGroup : 1,
					navigation:{
						nextEl:'.swiper-button-next',
						prevEl:'.swiper-button-prev',
					},				
				}
			}
		},
		computed:{
			swiper(){
				return this.$refs.mySwiper.swiper
			}
		},
		mounted(){
			this.swiper.slideTo(5,1000,false)
		}

	}

  
</script>

<style>
.swiper{
	/* max-height: 300px; */
	text-align: center;
}
.swiper-slide img{
	width: 80%;
	margin-left: 10%
}

</style>



// WEBPACK FOOTER //
// src/pages/services_weixin.vue